import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkles, Trash2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const DemoMembersPanel = () => {
  const [count, setCount] = useState(0);
  const [busy, setBusy] = useState(false);

  const refresh = async () => setCount((await api.get("/admin/demo-members")).data.count);
  useEffect(() => { refresh(); }, []);

  const run = async (method, msg) => {
    setBusy(true);
    try {
      await api[method]("/admin/demo-members");
      toast.success(msg);
      await refresh();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <div className="flex flex-wrap items-center gap-3 mb-6 bg-white border border-amber-100 rounded-2xl px-5 py-4 shadow-sm" data-testid="demo-members-panel">
      <div className="flex-1 min-w-[200px]">
        <p className="font-medium text-stone-900 text-sm">Demo map pins</p>
        <p className="text-stone-500 text-xs" data-testid="demo-members-count">
          {count} demo members on the radar map (not shown in portfolio)
        </p>
      </div>
      <Button data-testid="seed-demo-members-btn" disabled={busy} onClick={() => run("post", "15 demo members added to the map")}
        variant="outline" size="sm" className="rounded-full gap-2 border-rose-200 text-rose-600 hover:bg-rose-50">
        <Sparkles size={14} /> {count ? "Re-seed demo members" : "Seed demo members"}
      </Button>
      <Button data-testid="clear-demo-members-btn" disabled={busy || !count} onClick={() => run("delete", "Demo members removed")}
        variant="outline" size="sm" className="rounded-full gap-2 border-stone-300 text-stone-600">
        <Trash2 size={14} /> Remove all
      </Button>
    </div>
  );
};
